import { IconDefaultToken } from '@/assets/icon/token';
import React from 'react';
// import { IconDefaultToken } from ''

interface TokenIconProps {
  className?: string;
  style?: React.CSSProperties;
  src?: string;
  symbol?: string;
}

export const TokenIcon = (props: TokenIconProps) => {
  const { className, style, src, symbol } = props;
  // if (src) {
  return <img className={className} src={src || IconDefaultToken} style={style} alt={symbol} />;
  // }
  //   return (
  //     <div className={className} style={style}>
  //       {symbol?.trim()?.[0]?.toUpperCase() || '?'}
  //     </div>
  //   );
};
